<template>
  <button class="btn" :class="btnClass" @click="send" :disabled="isDisabled">
    <span>
      <i class="fas" :class="btnIcon"></i>
    </span>
  </button>
</template>
<script>
  export default {
    props: ['client', 'startDate', 'endDate', 'bus'],
    created() {
      this.bus.$on('send-invoices', client_id => {
        if (this.client.id === client_id) {
          if (!this.isDisabled) {
            this.send()
          }
        }
      })

      if (this.isSending) {
        this.poolInvoiceData();
      }
    },
    data() {
      return {
        sending: false,
      }
    },
    watch: {
      client: {
        handler() {
          this.sending = false
        },
        deep: true,
      }
    },
    computed: {
      btnIcon() {
        if (this.isFailed) {
          return 'fa-times'
        }
        if (this.isSending) {
          return 'fa-sync fa-spin'
        }
        if (this.isSent) {
          return 'fa-check'
        }
        return 'fa-paper-plane'
      },
      btnClass() {
        if (this.isFailed) {
          return 'btn-danger'
        }
        if (this.isSending) {
          return 'btn-warning'
        }
        if (this.isSent) {
          return 'btn-success'
        }
        return 'btn-info'
      },
      isFailed() {
        let failed = false
        _.each(this.client.invoices, invoice => {
          if (invoice.sending_failed) {
            failed = true
          }
        })

        return failed
      },
      isSent() {
        let sent = true
        _.each(this.client.invoices, invoice => {
          if (!invoice.sent_at) {
            sent = false
          }
        })

        return sent
      },
      isDisabled() {
        return this.isSending || this.isFailed || this.isSent
      },
      isSending() {
        let sending = false
        _.each(this.client.invoices, invoice => {
          if (invoice.is_sending) {
            sending = true
          }
        })

        return this.sending || sending
      }
    },
    methods: {
      send() {
        this.sending = true
        this.poolInvoiceData()
        this.axios.post('clients/send-invoice', {
          clients: [this.client.id],
          startDate: this.startDate,
          endDate: this.endDate
        })
      },
      poolInvoiceData() {
        this.$emit('poolInvoiceData')
      },
    }

  }
</script>



// WEBPACK FOOTER //
// src/views/financialReports/InvoiceSendButton.vue